import React from 'react'
import LeftMenu from './AnalyticsModule/Left'
import Button from "./../library/components/Button";
import { parseJwt } from './utilities/utils';
import { BASE_URLS } from '../constants/constants';
import file from './Files/ServiceVoter_and_ETPBMS_2024.pptx'
import { useNavigate } from 'react-router-dom';
import DownloadCard from './DownloadCard';
import RunnerUpHeaderNew from '../ui/runnerUpHeader/RunnerUpHeaderNew';
import { teal, purple, lime, red, green } from '@mui/material/colors';
const Downloads = () => {
const navigate = useNavigate()
const url = `${BASE_URLS.BALLOT_EXE_BASE_URL}`

const downloadFile = (path, filename) => {
  // Create a new link
  const anchor = document.createElement('a');
  anchor.href = path;
  anchor.download = filename;

  // Append to the DOM
  document.body.appendChild(anchor);

  // Trigger `click` event
  anchor.click();

  // Remove element from DOM
  document.body.removeChild(anchor);
}; 

  return (
    <LeftMenu>
         <div className='box container-fluid shadow'>
          <>
             <RunnerUpHeaderNew 
      title={"Downloads"}
      />
    {(localStorage?.userrole==="ceo" || localStorage?.userrole==="ceoa") && <>
    <div className='row' style={{display:"flex",justifyContent:"center"}}>
        <div className='col-md-6'>
          <a
      href={`${url}api/v1/epb-data/download-ballot-software?path=AC`} 
      download
      style={{ textDecoration: "none" ,color:"black"}}
    ><DownloadCard label={"Ballot Genaration Software (AC)"} color={lime} /></a>
        </div>
          <div className='col-md-6'>
     <a
      href={`${url}api/v1/epb-data/download-ballot-software?path=PC`}
      download
      style={{ textDecoration: "none" ,color:"black"}}
    ><DownloadCard label={"Ballot Genaration Software (PC)"} color={teal}  /></a>
      </div>
          <div className='col-md-6'>     <a
      onClick={()=>{downloadFile(file,'ServiceVoter_and_ETPBMS_2024.pptx')}}
      download
      style={{ textDecoration: "none" ,color:"black"}}
    ><DownloadCard label={"ETPBMS User Manual"} color={purple}  /></a>
    </div>
    </div>
     </> }
     {(localStorage.userrole==="ro" && parseJwt(localStorage.access_token)?.constituencyType==="AC")?  
      <>
       <div className="row my-3  file_ballot_DOWNLOAD">
        <div className="col-md-4 offset-md-2 file_button">
        <div className='download_class'>Offline Ballot Genaration Software (AC)</div>
        </div>
      <a href={`${url}api/v1/epb-data/download-ballot-software?path=AC`} className='link'>Click to download</a> 
      </div>
      <div className="row file_ballot_DOWNLOAD my-2">
       <div className="col-md-4 offset-md-2 file_button">
       <div className='download_class'>Online Ballot Genaration (AC) </div>
       </div>
      <a onClick={()=>{navigate("/ro/ballotCreation")}} className='link'>Click here</a> 
     </div>
       <div className="row file_ballot_DOWNLOAD my-2">
       <div className="col-md-4 offset-md-2 file_button">
       <div className='download_class'>ETPBMS User Manual</div>
       </div>
      <a onClick={()=>{downloadFile(file,'ServiceVoter_and_ETPBMS_2024.pptx')}} className='link'>Click to download</a> 
     </div>
     <div className="row file_ballot_DOWNLOAD my-2">
       <div className="col-md-4 offset-md-2 file_button">
       <div className='download_class'>Test Your QR Code Scanner</div>
       </div>
       <a onClick={()=>{navigate("/ro/TestQrScanner")}} className='link'>Click here</a> 
     </div>
      </>
      :(localStorage.userrole==="ro" && parseJwt(localStorage.access_token)?.constituencyType==="PC")?  
    <>
  <div className="row file_ballot_DOWNLOAD my-2">
        <div className="col-md-4 offset-md-2 file_button">
        <div className='download_class'>Ballot Genaration Software (PC)</div>
        </div>
       <a href={`${url}api/v1/epb-data/download-ballot-software?path=PC`} className='link'>Click to download</a> 
      </div>
      <div className="row file_ballot_DOWNLOAD my-2">
       <div className="col-md-4 offset-md-2 file_button">
       <div className='download_class'>Online Ballot Genaration (PC) </div>
       </div>
      <a onClick={()=>{navigate("/ro/ballotCreation")}} className='link'>Click here</a> 
     </div>
       <div className="row file_ballot_DOWNLOAD my-2">
       <div className="col-md-4 offset-md-2 file_button">
       <div className='download_class'>ETPBMS User Manual</div>
       </div>
      <a onClick={()=>{downloadFile(file,'ServiceVoter_and_ETPBMS_2024.pptx')}} className='link'>Click to download</a> 
     </div>
     <div className="row file_ballot_DOWNLOAD my-2">
       <div className="col-md-4 offset-md-2 file_button">
       <div className='download_class'>Test Your QR Code Scanner</div>
       </div>
       <a onClick={()=>{navigate("/ro/TestQrScanner")}} className='link'>Click here</a> 
     </div>
    </>
      :null}

          </>
         </div>
    </LeftMenu>
  )
}

export default Downloads